import 'purecss/build/pure.css';
import React, { PropsWithChildren } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { Icons } from '../Common/Icons';
import { acquireToken } from "../Common/Auth";
import { copilotBaseUrl } from "../Common/Environment";
import { ChatBubble } from "copilot-agents-react";
import { useCopilotBubble } from "../Contexts/CopilotBubbleContext";
import './Layout.css';
import SideBar from './SideBar';
import './SvgStyles.css';
import TopBar from './TopBar';
import type { HostedSite } from "../Routing/HostnameRouting";

interface Props {
    title: string;
    site?: HostedSite;
}

const Layout = (props: PropsWithChildren<Props>) => {
    const { config } = useCopilotBubble();

    React.useEffect(() => {
        document.title = props.title
    }, [props.title]);

    return (
        <Router>
            <>
                <div className="fxs-portal">
                    <TopBar title={props.title} siteName={props.site?.name} />
                    <div className="fxs-body-container">
                        <SideBar site={props.site} />
                        <div className="fxs-body">
                            {props.children}
                        </div>
                    </div>
                </div>
                <ChatBubble
                    hidden={!config.enabled}
                    preferredAgent={config.preferredAgent}
                    defaultAgent="concierge"
                    starterQuestions={config.starterQuestions}
                    panelTitle={`${props.site?.name || "Extension Analyzer"} Copilot`}
                    baseUrl={copilotBaseUrl}
                    dismissable={config.dismissable}
                    getAuthToken={async () => (await acquireToken()).accessToken}
                />
                {Icons.indicators}
            </>
        </Router>
    );
};

export default React.memo(Layout);
